module.exports = __webpack_public_path__ + "img/send-a-gift.8af113d8.svg";